module.exports = __webpack_public_path__ + "static/media/prev.900574bc.svg";